import React from "react";

function PageHeader(props) {
  return (
    <div className="page-header">
      <div className="page-title">
        <h4>{props.title}</h4>
        <p>{props.subject}</p>
      </div>

      <div className="page-filters">{props.children}</div>
    </div>
  );
}


export default PageHeader;
